<template>
<div class="ActivityList  bgc padding-20 box-shadow">
    <div class="filters">
        <div class="add">
            <el-button type="primary" @click="handleAdd">新增活动</el-button>
            <el-button type="success" @click="handleAddTemp">复制活动模板</el-button>
        </div>
        <div class="search">
            <el-input v-model="param.eventname" placeholder="请输入活动名称" class="condition" clearable></el-input>
            <el-select v-model="param.resulttype" placeholder="凭证类型" class="condition" clearable>
                <el-option v-for="item in resulttypeList" :key="item.code" :label="item.name"
                           :value="item.code"></el-option>
            </el-select>
            <el-select v-model="param.eventstatus" placeholder="活动状态" class="condition" clearable>
                <el-option v-for="item in statusList" :key="item.code" :label="item.name"
                           :value="item.code"></el-option>
            </el-select>
            <el-button type="primary" plain @click="handleQuery">搜索</el-button>
        </div>
    </div>
    <div class="result-list btn-operate-list bgc">
        <el-table :data="tableData" style="width: 100%;">
            <el-table-column label="活动名称" fixed class-name="left" min-width="296">
                <template slot-scope="scope">
                    <div class="nameBox">
                        <div class="iconBox">
                            <img :src="scope.row.coveratturlid?scope.row.coveratturlid:imgNoimg"
                                 :alt="scope.row.title">
                        </div>
                        <div class="rightBox">
                            <div class="title ">
                                <div class="text">{{scope.row.eventname}}</div>
                            </div>
                            <div class="tip">
                                <span :class="resulttype(scope.row.resulttype)" v-if="scope.row.resulttype!=5">{{scope.row.resulttypename}}</span>
                                <span v-if="scope.row.resulttype==5" class="tc-red">{{scope.row.logistypename}}</span>
                            </div>
                        </div>
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="活动起止时间" class-name="center" width="120">
                <template slot-scope="scope">
                    <div>
                        <div>{{scope.row.eventbegintime}}</div>
                        <div>{{scope.row.eventendtime}}</div>
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="浏览量" class-name="center" width="80">
                <template slot-scope="scope">{{scope.row.viewcount?scope.row.viewcount:'-'}}</template>
            </el-table-column>
            <el-table-column label="销量" class-name="center" width="80">
                <template slot-scope="scope">{{scope.row.ordersucccount?scope.row.ordersucccount:'-'}}</template>
            </el-table-column>
            <el-table-column label="销售额" class-name="center" width="80">
                <template slot-scope="scope">{{scope.row.ordermoney?'￥'+scope.row.ordermoney:'-'}}</template>
            </el-table-column>
            <el-table-column label="待发佣金" class-name="center" width="80">
                <template slot-scope="scope">{{scope.row.brokeragesettled?'￥'+scope.row.brokeragesettled:'-'}}
                </template>
            </el-table-column>
            <el-table-column label="开团数" class-name="center" width="80">
                <template slot-scope="scope">{{scope.row.opencount?scope.row.opencount:'-'}}</template>
            </el-table-column>
            <el-table-column label="活动状态" class-name="center" width="80">
                <template slot-scope="scope">
                    <div :class="eventstatus(scope.row.eventstatus)">{{scope.row.eventstatusname}}</div>
                </template>
            </el-table-column>
            <el-table-column label="操作" width="280" class-name="right">
                <template slot-scope="scope">
                    <div class="tr">
                        <span class="separator-btn">
                            <el-button @click="handleEditGoods(scope.row)" type="text" size="small">商品</el-button>
                        </span>
                        <span class="separator-btn"  v-if="[0, 9, 10].indexOf(scope.row.eventstatus)>-1">
                            <el-button @click="handleEdit(scope.row)" type="text" size="small">编辑</el-button>
                        </span>
                        <span class="separator-btn" v-else>
                            <el-button @click="handleView(scope.row)" type="text" size="small">详情</el-button>
                        </span>
                        <span class="separator-btn">
                            <el-button @click="handleEditLeader(scope.row)" type="text" size="small">团长</el-button>
                        </span>
                        <span class="separator-btn">
                            <el-button @click="handleToOrder(scope.row)" type="text" size="small">订单</el-button>
                        </span>
                        <span class="separator-btn">
                            <el-dropdown>
                                <span class="el-dropdown-link">
                                    <el-button type="text" size="small">更多</el-button>
                                </span>
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item @click.native="handleShare(scope.row)"  v-if="scope.row.eventstatus!=100">分享活动</el-dropdown-item>
                                    <el-dropdown-item @click.native="handlePoster(scope.row)">海报管理</el-dropdown-item>
                                    <el-dropdown-item @click.native="handleAnalysis(scope.row)">数据分析</el-dropdown-item>
                                    <el-dropdown-item @click.native="handleLeaderActivity(scope.row)">团长活动</el-dropdown-item>
                                    <el-dropdown-item @click.native="handleCopy(scope.row)">复制活动</el-dropdown-item>
                                    <el-dropdown-item @click.native="handleHide(scope.row)"  v-if="scope.row.eventstatus!=100 && scope.row.ispublic==1">隐藏活动</el-dropdown-item>
                                    <el-dropdown-item @click.native="handleShow(scope.row)"  v-if="scope.row.eventstatus!=100 && scope.row.ispublic==0">公开活动</el-dropdown-item>
                                    <el-dropdown-item @click.native="handleDel(scope.row)" v-if="[0, 9].indexOf(scope.row.eventstatus)>-1">删除活动</el-dropdown-item>
                                    <el-dropdown-item @click.native="handleClose(scope.row)" v-if="[0, 10, 11].indexOf(scope.row.eventstatus)>-1">结束活动</el-dropdown-item>
                                    <el-dropdown-item @click.native="handleDistribution(scope.row)" v-if="scope.row.isdisevent">分销员</el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                        </span>
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <page :total="total" @getList="_getList" ref="page"></page>
    </div>
    <invateLinkDialog ref="invateLinkDialog"></invateLinkDialog>
    <activityTempListDialog ref="activityTempListDialog"></activityTempListDialog>
    <leaderActivityDialog ref="leaderActivityDialog"></leaderActivityDialog>
    <activityDistributionDialog ref="activityDistributionDialog"></activityDistributionDialog>
</div>
</template>

<script>
import {checkModule} from '@/api/api'
import {getEventListByPage, uploadEventStatus, copyEventinfo} from 'api/brandBusiness'
import Page from 'base/page/page'
import {mapGetters, mapActions} from 'vuex'
import {brandBusiness} from 'api/enumCode'
import {urlToQRCode, downloadImage} from 'common/js/tools'
import InvateLinkDialog from 'views/brandBusiness/leaderMgt/myLeader/components/invateLinkDialog.vue'
import ActivityTempListDialog from 'views/brandBusiness/activityMgt/activity/components/activityTempListDialog.vue'
import LeaderActivityDialog from 'views/brandBusiness/activityMgt/activity/components/leaderActivityDialog.vue'
import ActivityDistributionDialog from 'views/brandBusiness/activityMgt/activity/components/activityDistributionDialog.vue'
export default {
    name: 'BBActivityList',
    data() {
        return {
            imgNoimg: require('@/common/images/nationalDistributionMenu/img-noimg.png'),
            statusList: brandBusiness.eventstatus,
            resulttypeList: brandBusiness.resulttype,
            dialogVisible: false,
            total: 0,
            tableData: [],
            power: [],
            rules: {},
            param: {
                brandname: '',
                eventname: '',
                eventstatus: '',
                eventtype: '',
                hostroletype: 2,
                resulttype: '',
                rolehostid: sessionStorage.getItem('brandBusiness') ? JSON.parse(sessionStorage.getItem('brandBusiness')).hostid : ''
            }
        }
    },
    mounted() {
        if (this.brandBusiness.hostid && !this.isRefresh) {
            this.param.rolehostid = this.brandBusiness.hostid
            this.setPage({page: 1, pageSize: 10})
            this._getList()
        }
    },
    activated() {
        if (this.brandBusiness.hostid && this.isRefresh) {
            this.param.rolehostid = this.brandBusiness.hostid
            if (this.isRefresh === 2) {
                this.param = {
                    brandname: '',
                    eventname: '',
                    eventstatus: '',
                    eventtype: '',
                    hostroletype: 2,
                    resulttype: '',
                    rolehostid: sessionStorage.getItem('brandBusiness') ? JSON.parse(sessionStorage.getItem('brandBusiness')).hostid : ''
                }
                this.setPage({page: 1, pageSize: 10})
            }
            this.$refs.page.handleSizeChange(this.page.page)
            this.setIsRefresh(0)
        }
    },
    methods: {
        handleDistribution(row) {
            this.$refs.activityDistributionDialog.openDialog(row.eventid)
        },
        handleLeaderActivity(row) {
            this.$refs.leaderActivityDialog.openDialog(row.eventid)
        },
        handleEditGoods(row) {
            this.setIsRefresh(2)
            this.$router.push({name: 'BBActivityGoodsList', query: {eventid: row.eventid, hostroletype: 2}})
        },
        handleEditLeader(row) {
            this.$router.push({name: 'BBActivityleaderList', query: {eventid: row.eventid, eventname: row.eventname}})
        },
        handleAnalysis(row) {
            this.$router.push({name: 'BBActivityDataAnalysis', query: {eventid: row.eventid, eventname: row.eventname}})
        },
        handleAddTemp() {
            let now = new Date()
            let expiredate = new Date(this.brandBusiness.expiredate)
            if (expiredate < now) {
                this.$confirm('该功能需要在订阅方可使用，建议尽快订阅，订阅后可继续使用该功能', '提示', {
                    confirmButtonText: '去订阅',
                    cancelButtonText: '取消'
                }).then(() => {
                    this.$router.push({name: 'BBRenew'})
                })
            } else {
                this.$refs.activityTempListDialog.openDialog()
            }
        },
        handleShare(row) {
            this.$refs.invateLinkDialog.openDialog(row.shareurl, '分享活动')
        },
        handleToOrder(row) {
            this.setIsRefresh(2)
            this.$router.push({name: 'BBActivityOrderList', query: {eventid: row.eventid}})
        },
        handleQuery() {
            this.$refs.page.handleSizeChange(1)
        },
        handleAdd() {
            let now = new Date()
            let expiredate = new Date(this.brandBusiness.expiredate)
            if (expiredate < now) {
                this.$confirm('该功能需要在订阅方可使用，建议尽快订阅，订阅后可继续使用该功能', '提示', {
                    confirmButtonText: '去订阅',
                    cancelButtonText: '取消'
                }).then(() => {
                    this.$router.push({name: 'BBRenew'})
                })
            } else {
                this.$router.push({name: 'BBActivityEdit', query: {eventsource: 2, hostroletype: 2}})
            }
        },
        handleEdit(row) {
            this.$router.push({name: 'BBActivityEdit', query: {eventid: row.eventid, eventsource: 2 , hostroletype: 2}})
        },
        handleView(row) {
            this.$router.push({name: 'BBActivityEdit', query: {eventid: row.eventid, eventsource: 2 , hostroletype: 2, isView: true}})
        },
        handlePoster(row) {
            this.$router.push({name: 'BBActivityPoster', query: {eventid: row.eventid}})
        },
        handleClose(row) {
            this.$confirm('确认结束该活动', '提示', {
                confirmButtonText: '确认',
                cancelButtonText: '取消'
            }).then(() => {
                this._editStatus(row.eventid, 1, '结束成功')
            })
        },
        handleHide(row) {
            this.$confirm('确认隐藏该活动', '提示', {
                confirmButtonText: '确认',
                cancelButtonText: '取消'
            }).then(() => {
                this._editStatus(row.eventid, 2, '隐藏成功')
            })
        },
        handleDel(row) {
            this.$confirm('确认删除该活动', '提示', {
                confirmButtonText: '确认',
                cancelButtonText: '取消'
            }).then(() => {
                this._editStatus(row.eventid, 100, '删除成功')
            })
        },
        handleShow(row) {
            this.$confirm('确认公开该活动', '提示', {
                confirmButtonText: '确认',
                cancelButtonText: '取消'
            }).then(() => {
                this._editStatus(row.eventid, 4, '公开成功')
            })
        },
        handleCopy(row) {
            this.$confirm('确认复制该活动', '提示', {
                confirmButtonText: '确认',
                cancelButtonText: '取消'
            }).then(() => {
                // this._copy(row.eventid)
                this.$router.push({name: 'BBActivityEdit', query: {eventid: row.eventid, fromeventid: row.eventid, eventsource: 2, iscopy: 1}})
            })
        },
        download(imgsrc, name) { // 下载图片地址和图片名
            downloadImage(imgsrc, name)
        },
        onCopy(e) {
            this.$message({
                message: '复制成功',
                type: 'success'
            })
        },
        onError(e) {
            alert('失败')
        },
        _copy(eventid) {
            this.setLoading(true)
            copyEventinfo({
                data: {eventid: eventid},
                success: data => {
                    this.$confirm('活动复制成功，请前往活动详情进行活动设置修改。', '提示', {
                        confirmButtonText: '进入活动编辑  >>',
                        showCancelButton: false,
                        confirmButtonClass: 'bbCopyActivity'
                    }).then(() => {
                        this.$router.push({name: 'BBActivityGoodsList', query: {eventid: eventid}})
                    })
                    this.setLoading(false)
                    this._getList()
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        _editStatus(innerid, status, tip) {
            // 活动状态(1结束 2隐藏 3删除 4公开)
            let obj = {
                eventid: innerid,
                status: status,
                eventtype: 10,
            }
            this.setLoading(true)
            uploadEventStatus({
                data: obj,
                success: data => {
                    this.$message.success(tip)
                    this.setLoading(false)
                    this._getList()
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        _getList() {
            this.setLoading(true)
            getEventListByPage({
                data: Object.assign({}, this.param, this.page),
                success: data => {
                    data.data.content.forEach((obj, index) => {
                        obj.sortNum = (this.$refs.page.page.page - 1) * 10 + index + 1
                    })
                    this.tableData = data.data.content
                    this.total = data.data.pageinfo.rowCount
                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        ...mapActions([
            'setLoading',
            'setParams',
            'setPage',
            'setIsRefresh'
        ])
    },
    filters: {},
    watch: {
        brandBusiness: {
            handler: function () {
                this._getList()
            },
            deep: true
        }
    },
    computed: {
        resulttype() {
            return function (value) {
                for (let i = 0; i < brandBusiness.resulttype.length; i++) {
                    if (value === brandBusiness.resulttype[i].code) {
                        return brandBusiness.resulttype[i].cls
                    }
                }
                return value
            }
        },
        eventstatus() {
            return function (value) {
                for (let i = 0; i < brandBusiness.eventstatus.length; i++) {
                    if (value === brandBusiness.eventstatus[i].code) {
                        return brandBusiness.eventstatus[i].cls
                    }
                }
                return value
            }
        },
        ...mapGetters([
            'page',
            'user',
            'permission',
            'params',
            'brandBusiness',
            'isRefresh'
        ])
    },
    components: {
        Page, InvateLinkDialog, ActivityTempListDialog, LeaderActivityDialog, ActivityDistributionDialog
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/mixin";

.el-message-box__content {
    padding: 30px 50px !important;
    text-align: center !important;
    color: #F56C6C !important;
}

.el-message-box__btns {
    text-align: center !important;
    .el-button {
        margin-bottom: 30px !important;
    }
}

.bbCopyActivity{
    background: #fff;
    padding: 0 30px;
    border: 1px solid #C0C4CC;
    color: #C0C4CC;
}
.ActivityList {
    .filters {
        .el-input input {
            width: 180px;
        }
        .el-select .el-input input {
            width: 108px;
        }
    }
    .result-list {
        .el-table__row {
            height: 100px;
        }
        .el-table__body, .el-table__header {
            width: 100% !important;
        }
        .left {
            .cell {
                text-align: left;
                font-weight: 600;
                .nameBox {
                    display: flex;
                    .iconBox {
                        width: 106px;
                        height: 60px;
                        flex-shrink: 0;
                        flex-grow: 0;
                        margin-right: 10px;
                        img {
                            min-width: 106px;
                            height: 60px;
                        }
                    }
                    .rightBox {
                        min-width: 104px;
                        display: flex;
                        flex-direction: column;
                        .title {
                            height: 40px;
                            line-height: 20px;
                            overflow: hidden;
                            .text {
                                font-weight: 600;
                                float: right;
                                /* "margin-left"要等于".wrap::before"的宽度 */
                                margin-left: -10px;
                                width: 100%;
                                word-break: break-all;
                                text-align: left;
                                font-size: 14px;
                                // font-size: 0.48rem;
                            }
                            &::before {
                                float: left;
                                content: '';
                                width: 10px;
                                height: 100%;
                            }
                            &::after {
                                float: right;
                                content: "...";
                                /* 行高与".wrap"设置的一致即可 */
                                height: 40px;
                                line-height: 20px;
                                /* 设置三个省略号的宽度,大于字体文本宽度即可,数值随意。并使盒子不占位置 */
                                width: 37px;
                                margin-left: -37px;
                                /* 移动省略号位置 */
                                position: relative;
                                left: 101.9%;
                                bottom: 20px;
                                font-weight: 600;
                                padding-right: 1px;
                                background: #fff;
                                transition: all 0.5s;
                                text-align: left;
                            }
                        }
                        .tip {
                            font-size: 12px;
                            span + span {
                                margin-left: 10px;
                            }
                        }
                        .type {
                            text-align: left;
                        }
                        .type1 {
                            color: #67C23A;
                        }
                        .type2 {
                            color: #409EFF;
                        }
                        .type3 {
                            color: #E6A23C;
                        }
                        .type4 {
                            color: #F56C6C;
                        }
                    }
                }
            }
        }
        .right {
            .cell {
                text-align: right;
            }
        }
        .center {
            .cell {
                text-align: center;
                padding: 0;
                .nameBox {
                    display: flex;
                    .iconBox {
                        width: 106px;
                        height: 60px;
                        margin-right: 10px;
                        img {
                            min-width: 106px;
                            height: 60px;
                        }
                    }
                }
                .ing {
                    color: #67C23A;
                }
            }
        }
        .el-table__row:hover {
            .left {
                .cell {
                    .title {
                        &::after {
                            background: #F5F7FA;
                        }
                    }
                }
            }
        }
        .imageText {
            .imageText-summary {
                margin-left: 5px;
                .textBox {
                    width: 345px;
                    height: 40px;
                    line-height: 20px;
                    overflow: hidden;
                    .text {
                        float: right;
                        /* "margin-left"要等于".wrap::before"的宽度 */
                        margin-left: -10px;
                        width: 345px;
                        word-break: break-all;
                        // font-size: 0.48rem;
                    }
                    &::before {
                        float: left;
                        content: '';
                        width: 10px;
                        height: 100%;
                    }
                    &::after {
                        float: right;
                        content: "...";
                        /* 行高与".wrap"设置的一致即可 */
                        height: 40px;
                        line-height: 20px;
                        /* 设置三个省略号的宽度,大于字体文本宽度即可,数值随意。并使盒子不占位置 */
                        width: 37px;
                        margin-left: -37px;
                        /* 移动省略号位置 */
                        position: relative;
                        left: 101.8%;
                        bottom: 20px;
                        font-weight: 600;
                        padding-right: 1px;
                        background: #fff;
                        transition: all 0.5s;
                    }
                    .recommon {
                        color: #fff;
                        background: #E6A23C;
                        display: inline-block;
                        width: 36px;
                        height: 16px;
                        line-height: 16px;
                        text-align: center;
                        margin-right: 5px;
                        font-size: 12px;
                    }
                }
                .price {
                    margin-left: 5px;
                    color: #F56C6C;
                }
            }
        }
        .el-table__row:hover {
            .textBox {
                &::after {
                    background: #F5F7FA;
                }
            }
        }
        img {
            min-width: 100px;
            max-width: 100px;
            height: 60px;
        }
        .icon {
            margin-left: 10px;
            width: 14px;
            height: 14px;
        }
    }
    .result-list .imageText .imageText-summary div:nth-child(1) {
        margin-bottom: 0;
    }
    .el-table {
        .title {
            .cell {
                padding: 0;
                margin-left: 5px;
            }
        }
        .center {
            .cell {
                text-align: center;
            }
        }
    }
}

</style>
